import generateBasicCardBlock from './generateBasicCardBlock';

const generatePhotoCard = (title, date, imageUrl) => {
	const template = generateBasicCardBlock(title, date, imageUrl);

	template.classList.add('modal-marker');
	template.setAttribute('data-target', 'guest-photo');

	template.addEventListener('click', () => {
		document.querySelector('.guest-photo > .image').style.backgroundImage = `url(${imageUrl})`;
		document.querySelector('.guest-photo > .title').innerText = title;
	});

	return template;
};

export default generatePhotoCard;



// WEBPACK FOOTER //
// ./src/js/about/generatePhotoCard.js